export const PAY_IN_FULL_DESCRIPTION =
  'Unfortunately, we are unable to approve a traditional payment plan at this time due to your financial history or unverified information. You can pay the full amount now, or you can go back and select a different payment option.';

export const PAY_PLAN_DESCRIPTION =
  'Unfortunately, we are unable to approve a traditional payment plan at this time due to your financial history or unverified information. We’re happy to offer you an alternate plan, or you can go back and select a different payment option.';
